import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import axios from "axios";

import {
  AUTH_STATE,
  LOGIN_USER,
  PROFILE,
  POST_PROFILE,
  LOGIN,
  REGISTER,
  REGISTER_USER,
  JWT,
  SEARCH_DATA,
  ME_DATA,
  PROFILE_DATA,
  EMAIL,
  PASSWORDRESET_DATA,
} from "../../types/types";

//非同期関数
//ログイン処理関数　ログインを実施し、JWTtokenを取得
//引数から必要なemailとpassを使用
export const fetchAsyncGetJWT = createAsyncThunk(
  "auth/getJWT",
  async (auth: LOGIN) => {
    const uploadData = new FormData();
    auth.email && uploadData.append("email", auth.email);
    auth.password1 && uploadData.append("password", auth.password1);

    const res = await axios.post<JWT>(
      `${process.env.REACT_APP_API_URL}/authen/jwt/create/`,
      uploadData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  }
);
export const fetchAsyncLogin = createAsyncThunk(
  "auth/login",
  async (auth: LOGIN) => {
    const uploadData = new FormData();
    auth.email && uploadData.append("email", auth.email);
    auth.password1 && uploadData.append("password", auth.password1);

    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/rest-auth/login/`,
      uploadData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return res.data;
  }
);

//ユーザ仮登録メール送信
export const fetchAsyncRegister = createAsyncThunk(
  "auth/register",
  async (auth: REGISTER) => {
    const res = await axios.post<REGISTER_USER>(
      `${process.env.REACT_APP_API_URL}/rest-auth/registration/`,
      auth,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  }
);

//本登録　メール認証
export const fetchAsyncActivation = createAsyncThunk(
  "auth/activation",
  async (key: Object) => {
    const res = await axios.post<REGISTER_USER>(
      `${process.env.REACT_APP_API_URL}/rest-auth/registration/verify-email/`,
      key,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  }
);

//ログインユーザの情報取得（id,username）
export const fetchAsyncCheckProfile = createAsyncThunk("auth/me", async () => {
  const res = await axios.get<ME_DATA>(
    `${process.env.REACT_APP_API_URL}/api/me/`,
    {
      headers: {
        Authorization: `JWT ${localStorage.localJWT}`,
      },
    }
  );

  return res.data;
});

//ログインユーザ情報取得関数(idのみ)
export const fetchAsyncLoginUser = createAsyncThunk(
  "auth/loginuser",
  async () => {
    const res = await axios.get<LOGIN_USER>(
      `${process.env.REACT_APP_API_URL}/api-data/loginuser/`,
      {
        headers: {
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return res.data;
  }
);
//ログインが有効期限内か確認
export const fetchAsyncLoginUserJWT = createAsyncThunk(
  "auth/loginuserJWT",
  async () => {
    const res = await axios.get<LOGIN_USER>(
      `${process.env.REACT_APP_API_URL}/api-data/loginuser/`,
      {
        headers: {
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return res.data;
  }
);

//パスワードリセットメールを送信
export const fetchAsyncPasswordReset = createAsyncThunk(
  "auth/passReset",
  async (email: EMAIL) => {
    await axios.post(
      `${process.env.REACT_APP_API_URL}/rest-auth/password/reset/`,
      email,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  }
);
//パスワード再設定処理
export const fetchAsyncPasswordChange = createAsyncThunk(
  "auth/passChange",
  async (data: PASSWORDRESET_DATA) => {
    await axios.post(
      `${process.env.REACT_APP_API_URL}/rest-auth/password/reset/confirm/`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  }
);

//特定ユーザのプロフィールを取得
export const fetchAsyncGetUsersProfile = createAsyncThunk(
  "auth/usersProfile",
  async (id: number) => {
    const res = await axios.get<PROFILE_DATA>(
      `${process.env.REACT_APP_API_URL}/api-data/profile/?user_profile=${id}`,
      {
        headers: {
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return res.data;
  }
);
//特定ユーザのプロフィールidからプロフィールを取得(プロフィール検索にて使用)
export const fetchAsyncGetUsersProfileId = createAsyncThunk(
  "auth/usersProfileId",
  async (id: number) => {
    const res = await axios.get<PROFILE_DATA>(
      `${process.env.REACT_APP_API_URL}/api-data/profile/?id=${id}`,
      {
        headers: {
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return res.data;
  }
);
//特定ユーザのプロフィールを取得
export const fetchAsyncSearchUsersProfile = createAsyncThunk(
  "auth/usersSearchProfile",
  async (category: SEARCH_DATA) => {
    let min_height = category.height > 0 ? category.height - 10 : "";
    let max_height = category.height > 0 ? category.height + 10 : "";
    let min_weight = category.weight > 0 ? category.weight - 10 : "";
    let max_weight = category.weight > 0 ? category.weight + 10 : "";
    let height_flg = category.height > 0 ? "1" : "";
    let weight_flg = category.weight > 0 ? "1" : "";
    let username = category.searchWord.length > 0 ? category.searchWord : "";
    const res = await axios.get<PROFILE_DATA>(
      `${process.env.REACT_APP_API_URL}/api-data/profile/?user_profile=&height_min=${min_height}&height_max=${max_height}&weight_min=${min_weight}&weight_max=${max_weight}&username=${username}&gender_flg=${category.gender}&height_hide_flg=${height_flg}&weight_hide_flg=${weight_flg}`,
      {
        headers: {
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return res.data.results;
  }
);

//プロフィール作成関数 img,height,weightはnullで作成
export const fetchAsyncCreateProfile = createAsyncThunk(
  "auth/createProfile",
  async (name: string) => {
    const res = await axios.post<PROFILE>(
      `${process.env.REACT_APP_API_URL}/api-data/profile/`,
      {
        username: name,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return res.data;
  }
);

//プロフィール取得関数
export const fetchAsyncGetProfiles = createAsyncThunk(
  "auth/getProfiles",
  async (para: SEARCH_DATA) => {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api-data/profile/`,
      {
        headers: {
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return res.data;
  }
);

//ログインユーザのプロフィール取得関数
export const fetchAsyncGetLoginProfile = createAsyncThunk(
  "auth/getLoginProfiles",
  async () => {
    const res = await axios.get<PROFILE_DATA>(
      `${process.env.REACT_APP_API_URL}/api-data/login_profile/`,
      {
        headers: {
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return res.data.results[0];
  }
);

//プロフィール更新関数
export const fetchAsyncUpdateProfile = createAsyncThunk(
  "auth/updateProfile",
  async (profile: POST_PROFILE) => {
    const uploadData = new FormData();

    //新たな画像が選択されている場合,imgに画像データをセット
    if (profile.newImg?.name !== "") {
      profile.newImg &&
        uploadData.append("img", profile.newImg, profile.newImg.name);
    }
    // 更新に使用するformDataを作成
    profile.username && uploadData.append("username", profile.username);
    profile.gender_flg && uploadData.append("gender_flg", profile.gender_flg);
    // profile.height && uploadData.append("height", String(profile.height));
    profile.height && uploadData.append("height", String(profile.height));
    profile.height_hide_flg &&
      uploadData.append("height_hide_flg", profile.height_hide_flg);
    profile.weight && uploadData.append("weight", String(profile.weight));
    profile.weight_hide_flg &&
      uploadData.append("weight_hide_flg", profile.weight_hide_flg);
    profile.text && uploadData.append("text", profile.text);
    profile.calendar_hide_flg &&
      uploadData.append("calendar_hide_flg", profile.calendar_hide_flg);

    if (profile.newImg?.name !== "") {
      // 画像の更新が必要な場合がimgを含む全てのデータを更新(PUT)
      const res = await axios.put<PROFILE>(
        `${process.env.REACT_APP_API_URL}/api-data/profile/${profile.id}/`,
        uploadData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `JWT ${localStorage.localJWT}`,
          },
        }
      );
      return res.data;
    } else {
      //画像の更新が不要な場合、img以外のデータを更新(PATCH)
      const res = await axios.patch<PROFILE>(
        `${process.env.REACT_APP_API_URL}/api-data/profile_patch/${profile.id}`,
        uploadData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `JWT ${localStorage.localJWT}`,
          },
        }
      );
      res.data.img = profile.img;
      return res.data;
    }
  }
);

export const initialState: AUTH_STATE = {
  isLoginView: true,
  loginUser: {
    id: 0,
  },
  loginUsername: {
    id: 0,
    username: "",
    is_admin: false,
  },
  loginUserProfile: {
    id: 0,
    username: "",
    user_profile: 0,
    img: null,
    gender_flg: "",
    height: null,
    height_hide_flg: "",
    weight: null,
    weight_hide_flg: "",
    text: null,
    calendar_hide_flg: "",
  },
  profiles: [
    {
      id: 0,
      username: "",
      user_profile: 0,
      img: null,
      gender_flg: "",
      height: null,
      height_hide_flg: "",
      weight: null,
      weight_hide_flg: "",
      text: null,
      calendar_hide_flg: "",
    },
  ],
  isError: false,
  selectedProfile: {
    count: 0,
    next: null,
    previous: null,
    results: [
      {
        id: 0,
        username: "",
        user_profile: 0,
        img: null,
        gender_flg: "",
        height: null,
        height_hide_flg: "",
        weight: null,
        weight_hide_flg: "",
        text: null,
        calendar_hide_flg: "",
      },
    ],
  },
  editedProfile: {
    id: 0,
    username: "",
    user_profile: 0,
    img: null,
    gender_flg: "",
    height: null,
    height_hide_flg: "",
    weight: null,
    weight_hide_flg: "",
    text: null,
    calendar_hide_flg: "",
  },
};

export const authSlice = createSlice({
  name: "auth",
  initialState,

  reducers: {
    //ログインかユーザ登録かを切り替え
    toggleMode(state) {
      state.isLoginView = !state.isLoginView;
    },
    editProfile(state, action: PayloadAction<PROFILE>) {
      state.editedProfile = action.payload;
    },
    setProfiles(state, action: PayloadAction<PROFILE[]>) {
      state.profiles = action.payload;
    },
    clearSelectedProfile(state) {
      state.selectedProfile = initialState.selectedProfile;
    },
  },
  extraReducers: (builder) => {
    //ログイン処理が正常終了後、JWTtokenをlocalStrageへ格納
    builder.addCase(
      fetchAsyncGetJWT.fulfilled,
      (state, action: PayloadAction<JWT>) => {
        localStorage.setItem("localJWT", action.payload.access);
      }
    );
    builder.addCase(fetchAsyncLogin.rejected, (state, action: any) => {
      return {
        ...state,
        isError: true,
      };
    });

    builder.addCase(
      fetchAsyncLoginUser.fulfilled,
      (state, action: PayloadAction<LOGIN_USER>) => {
        return {
          ...state,
          loginUser: action.payload,
        };
      }
    );
    builder.addCase(fetchAsyncLoginUser.rejected, () => {
      window.location.href = "/login";
    });
    builder.addCase(
      fetchAsyncLoginUserJWT.fulfilled,
      (state, action: PayloadAction<LOGIN_USER>) => {
        window.location.href = "/home";
      }
    );

    builder.addCase(
      fetchAsyncGetProfiles.fulfilled,
      (state, action: PayloadAction<PROFILE[]>) => {
        return {
          ...state,
          profiles: action.payload,
        };
      }
    );
    builder.addCase(
      fetchAsyncGetUsersProfile.fulfilled,
      (state, action: PayloadAction<PROFILE_DATA>) => {
        return {
          ...state,
          selectedProfile: action.payload,
        };
      }
    );
    builder.addCase(
      fetchAsyncGetUsersProfileId.fulfilled,
      (state, action: PayloadAction<PROFILE_DATA>) => {
        return {
          ...state,
          selectedProfile: action.payload,
        };
      }
    );
    builder.addCase(
      fetchAsyncGetLoginProfile.fulfilled,
      (state, action: PayloadAction<PROFILE>) => {
        return {
          ...state,
          loginUserProfile: action.payload,
        };
      }
    );
    builder.addCase(fetchAsyncGetLoginProfile.rejected, () => {
      window.location.href = "/login";
    });
    builder.addCase(
      fetchAsyncSearchUsersProfile.fulfilled,
      (state, action: PayloadAction<PROFILE[]>) => {
        return {
          ...state,
          profiles: action.payload,
        };
      }
    );
    builder.addCase(
      fetchAsyncCheckProfile.fulfilled,
      (state, action: PayloadAction<ME_DATA>) => {
        fetchAsyncGetUsersProfile(action.payload.id);
      }
    );
    builder.addCase(
      fetchAsyncUpdateProfile.fulfilled,
      (state, action: PayloadAction<PROFILE>) => {
        return {
          ...state,
          loginUserProfile: action.payload,
          profiles: state.profiles.map((prof) =>
            prof.id === action.payload.id ? action.payload : prof
          ),
        };
      }
    );
    builder.addCase(fetchAsyncUpdateProfile.rejected, () => {
      window.location.href = "/login";
    });
    builder.addCase(fetchAsyncPasswordChange.fulfilled, () => {
      // window.location.href = "/login";
    });
    builder.addCase(fetchAsyncPasswordChange.rejected, (state) => {
      return {
        ...state,
        isError: true,
      };
    });
    builder.addCase(fetchAsyncActivation.rejected, () => {
      window.location.href = "/login";
    });
    builder.addCase(fetchAsyncRegister.rejected, (state) => {
      return {
        ...state,
        isError: true,
      };
    });
  },
});

//コンポーネントで使用したいアクションをエクスポート
export const { toggleMode, editProfile, setProfiles, clearSelectedProfile } =
  authSlice.actions;

//コンポーネントからuseSelectarで使用できるようにstateをエクスポート
export const selectIsLoginView = (state: RootState) => state.auth.isLoginView;
export const selectLoginUser = (state: RootState) => state.auth.loginUser;
export const selectProfiles = (state: RootState) => state.auth.profiles;
export const selectIsError = (state: RootState) => state.auth.isError;
export const selectSelectedProfile = (state: RootState) =>
  state.auth.selectedProfile;
export const selectEditedProfile = (state: RootState) =>
  state.auth.editedProfile;
export const selectLoginUsername = (state: RootState) =>
  state.auth.loginUsername;
export const selectLoginUserProfile = (state: RootState) =>
  state.auth.loginUserProfile;

export default authSlice.reducer;
